var render, staticRenderFns
import script from "./associated_position_one.vue?vue&type=script&lang=js&"
export * from "./associated_position_one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a72fc3a')) {
      api.createRecord('6a72fc3a', component.options)
    } else {
      api.reload('6a72fc3a', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/organization_management/associated/position_maintenance/associated_position_one.vue"
export default component.exports